import { useEffect } from "react";

const SITE_ORIGIN = "https://magicznakeratyna.pl";

/**
 * Dynamically updates the <link rel="canonical"> tag in <head>.
 * 
 * Critical for SEO in SPAs: without this, every route would share the
 * canonical URL hardcoded in index.html (the homepage), causing Google
 * to treat all subpages as duplicates of the homepage and skip indexing.
 *
 * @param path - URL path starting with "/" (e.g. "/blog", "/blog/my-post")
 */
export const useCanonical = (path: string) => {
  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    const previous = link.getAttribute("href");
    link.setAttribute("href", url);

    return () => {
      // Restore homepage canonical when leaving the route so the static
      // tag from index.html semantics are preserved on the root page.
      if (previous) {
        link?.setAttribute("href", previous);
      }
    };
  }, [path]);
};
